// extracted by mini-css-extract-plugin
export default {"NavigationWarning":"C_lAVJuv3R5Th7znwsup"};